<template>
  <div class="apInputSearch">
    <div class="apInputSearch__inner">
      <div class="apInputSearch__field">
        <div>
          <img
            src="@/assets/icons/search.svg"
            alt="search"
            class="apInputSearch__img"
          >
        </div>
        <input
          class="apInputSearch__input"
          :value="modelValue"
          :placeholder="placeholder"
        >
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'ApSearch',

  props: {
    modelValue: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Продукт, услуга или магазин'
    },
  },

  setup(props, { emit }) {
    const input = (e: Event) : void => {
      const text = e.target as HTMLInputElement;
      emit('update:modelValue', text.value.replace(/\s/g, ''));
    };
    return {
      input
    };
  },
});
</script>

<style lang="scss" scoped>
.apInputSearch{
  display: flex;
  flex-direction: column;
  background-color: $primary-white;
  border-radius: 6px;

  &__inner{
    border-radius: 6px;
  }
  &__input{
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    border: none;
    &:focus{
      outline: none;
    }
  }
  &__img{
    display: block;
    margin-right: 10px;
  }
  &__hint {
      font-size: 12px;
      margin-top: 6px;
      color: rgba(0,0,0, .6);
  }
  &__field{
    display: flex;
    border: 1px solid rgba(176, 183, 195, 0.6);
    border-radius: 6px;
    overflow: hidden;
    padding: 10px;
    align-items: center;
    width: 100%;
    position: relative;
    line-height: 22px;
    &--border{
      border: none;
    }
  }
  &__label{
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    color: rgba(0, 0, 0, 0.72);
    margin-bottom: 6px;
    display: block;
  }
  &__icon{
    display: block;
    height: 24px;
    width: 24px;
  }
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
